/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-material': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#6ca2ca"><path pid="0" d="M1 16.456h17.774a.5.5 0 0 0 0-1H.999a.5.5 0 1 0 0 1z"/><path pid="1" d="M11.843 11.002a.5.5 0 0 1 .5-.5h4.76a.5.5 0 0 1 .5.5v4.604a.5.5 0 0 1-.5.5h-4.76a.5.5 0 0 1-.5-.5zm1 .5v3.604h3.76v-3.604z"/><path pid="2" d="M7.082 11.002a.5.5 0 0 1 .5-.5h4.761a.5.5 0 0 1 .5.5v4.604a.5.5 0 0 1-.5.5h-4.76a.5.5 0 0 1-.5-.5zm1 4.104h3.761v-3.604h-3.76z"/><path pid="3" d="M11.843 6.398a.5.5 0 0 1 .5-.5h4.76a.5.5 0 0 1 .5.5v4.604a.5.5 0 0 1-.5.5h-4.76a.5.5 0 0 1-.5-.5zm1 4.104h3.76V6.898h-3.76zM3.836 3a.5.5 0 0 1 .5-.5h4.76a.5.5 0 0 1 .5.5v4.604a.5.5 0 0 1-.5.5h-4.76a.5.5 0 0 1-.5-.5zm1 .5v3.604h3.76V3.5z"/></g>'
  }
})
